/* src/app/shared/components/document-modal/document-modal.component.scss */
.document-modal {
  display: grid;
  gap: 16px;
}
.date-content {
  overflow-wrap: break-word;
  word-break: break-all;
}
/*# sourceMappingURL=document-modal.component.css.map */
